import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LoadingService } from './core/services/loading.service';
import { MemoryManagerService } from './core/services/memory-manager.service';
import { filter, Subscription } from 'rxjs';


@Component({
  selector: 'mm-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  hideBanner = false;
  private routerSub: Subscription;

  constructor(
    public loadingService: LoadingService,
    private readonly router: Router,
    private readonly memoryManager: MemoryManagerService,
  ) {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        const url = (event as NavigationEnd).urlAfterRedirects;
        this.hideBanner = url.includes('/mobilescreen');
      });
  }

  ngOnInit(): void {
    // Activate memory management: watchdog, idle cleanup, auto-scheduler
    this.memoryManager.initialize();
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }
}
